import {initialize} from "./initialize"
import {pageview} from "./pageview"
import {event} from "./event"

export const analytics = {
    initialize,
    pageview,
    event,
}